var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1814093_calendar_events_schedule_icon 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-133",
    d: "M27.9 30.375H8.1C6.75 30.375 5.625 29.25 5.625 27.9V9.73122C5.625 8.38122 6.525 7.25623 7.70625 7.25623H8.94375V8.88747H7.70625C7.5375 8.88747 7.3125 9.22497 7.3125 9.73122V27.9C7.3125 28.35 7.70625 28.7437 8.15625 28.7437H27.9563C28.4062 28.7437 28.8 28.35 28.8 27.9V9.73122C28.8 9.22497 28.5187 8.88747 28.4062 8.88747H27.1687V7.25623H28.4062C29.5312 7.25623 30.4875 8.38122 30.4875 9.73122V27.9C30.375 29.25 29.25 30.375 27.9 30.375Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-134",
    d: "M11.4189 10.575C10.9689 10.575 10.5752 10.1812 10.5752 9.73122V6.41248C10.5752 5.96248 10.9689 5.56873 11.4189 5.56873C11.8689 5.56873 12.2627 5.96248 12.2627 6.41248V9.73122C12.2064 10.1812 11.8689 10.575 11.4189 10.575Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-135",
    d: "M24.5811 10.575C24.1311 10.575 23.7373 10.1812 23.7373 9.73122V6.41248C23.7373 5.96248 24.1311 5.56873 24.5811 5.56873C25.0311 5.56873 25.4248 5.96248 25.4248 6.41248V9.73122C25.4248 10.1812 25.0311 10.575 24.5811 10.575Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-136",
    d: "M13.8936 7.25623H22.1061V8.94373H13.8936V7.25623Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-137",
    d: "M7.25635 12.2062H28.7438V13.8937H7.25635V12.2062Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-138",
    d: "M25.4248 15.525H27.0561V17.1563H25.4248V15.525Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-139",
    d: "M22.1064 15.525H23.7939V17.1563H22.1064V15.525Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-140",
    d: "M18.8438 15.525H20.475V17.1563H18.8438V15.525Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-141",
    d: "M15.5249 15.525H17.1562V17.1563H15.5249V15.525Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-142",
    d: "M12.2061 15.525H13.8936V17.1563H12.2061V15.525Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-143",
    d: "M25.4248 18.8438H27.0561V20.475H25.4248V18.8438Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-144",
    d: "M22.1064 18.8438H23.7939V20.475H22.1064V18.8438Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-145",
    d: "M18.8438 18.8438H20.475V20.475H18.8438V18.8438Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-146",
    d: "M15.5249 18.8438H17.1562V20.475H15.5249V18.8438Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-147",
    d: "M12.2061 18.8438H13.8936V20.475H12.2061V18.8438Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-148",
    d: "M8.94385 18.8438H10.5751V20.475H8.94385V18.8438Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-149",
    d: "M25.4248 22.1062H27.0561V23.7937H25.4248V22.1062Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-150",
    d: "M22.1064 22.1062H23.7939V23.7937H22.1064V22.1062Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-151",
    d: "M18.8438 22.1062H20.475V23.7937H18.8438V22.1062Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-152",
    d: "M15.5249 22.1062H17.1562V23.7937H15.5249V22.1062Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-153",
    d: "M12.2061 22.1062H13.8936V23.7937H12.2061V22.1062Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-154",
    d: "M8.94385 22.1062H10.5751V23.7937H8.94385V22.1062Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-155",
    d: "M22.1064 25.4249H23.7939V27.0562H22.1064V25.4249Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-156",
    d: "M18.8438 25.4249H20.475V27.0562H18.8438V25.4249Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-157",
    d: "M15.5249 25.4249H17.1562V27.0562H15.5249V25.4249Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-158",
    d: "M12.2061 25.4249H13.8936V27.0562H12.2061V25.4249Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-159",
    d: "M8.94385 25.4249H10.5751V27.0562H8.94385V25.4249Z",
    fill: "#888888"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.61eeee5d2c40bc7bfc6840e4a78d51fa.svg";
export { ForwardRef as ReactComponent };